import { FC } from 'react';
import clsx from 'clsx';
import { isEmpty } from 'ramda';
import { Box, Overlay } from '@alf/uikit';
import { CommonLoader } from '@namespace/common';
import { useThemeComponents } from '@namespace/themes';
import { Card } from '../../api/bankCard/types';
import { STORE_PROPS, usePaymentsStore } from '../../store';
import { FirstDepositInfoMessage as DefaultFirstDepositInfoMessage } from '../FirstDepositInfoMessage';
import { InfoMessage } from '../InfoMessage';
import { ServiceProperties } from '../ServiceProperties/connector';

import styles from './index.module.css';

const { USER_TOKENS, ACTIVE_PAYMENT_TYPE } = STORE_PROPS;

export type PaymentFormWrapperProps = {
  activePaymentName?: string;
  cardList?: Card[] | null;
  children?: JSX.Element | (JSX.Element | null | false | undefined)[];
  className?: string;
  customFormWrapper?: string;
  customInfoMessage?: string;
  customServiceWrapper?: string;
  hasInfoMessage?: boolean;
  haveServiceProperties?: boolean;
  isCrypto?: boolean;
  isFullWidthMessage?: boolean;
  isLoading?: boolean;
  isNeedSuccessDeposit?: boolean;
  isUserCardsLoaded?: boolean;
  withLimits?: boolean;
  customInfoComp?: () => JSX.Element;
};

export const PaymentFormWrapper: FC<PaymentFormWrapperProps> = ({
  className = '',
  customInfoComp: CustomInfoMsg,
  customInfoMessage,
  isFullWidthMessage,
  children,
  activePaymentName,
  haveServiceProperties = true,
  hasInfoMessage = true,
  isUserCardsLoaded,
  cardList = [],
  isNeedSuccessDeposit = true,
  withLimits,
  customFormWrapper = '',
  customServiceWrapper = '',
  isLoading = false,
  isCrypto = false
}) => {
  const { activePaymentType, userTokens } = usePaymentsStore([
    ACTIVE_PAYMENT_TYPE,
    USER_TOKENS
  ]);
  const isCardListEmpty = isUserCardsLoaded && isEmpty(cardList);
  const cards = isCardListEmpty ? userTokens : cardList;

  const { FirstDepositInfoMessage = DefaultFirstDepositInfoMessage } =
    useThemeComponents();

  if (isLoading) {
    return (
      <Overlay>
        <CommonLoader />
      </Overlay>
    );
  }

  if (isUserCardsLoaded && isEmpty(cards) && isNeedSuccessDeposit) {
    return <FirstDepositInfoMessage activePaymentName={activePaymentName} />;
  }

  return (
    <Box className={className} direction="column">
      {hasInfoMessage && (
        <Box top="m">
          <InfoMessage
            className={clsx(isFullWidthMessage && styles.infoMessage)}
            customMessageComp={CustomInfoMsg}
            message={
              customInfoMessage ||
              `personalOffice.balance.sw.${activePaymentType}.forms.attentionMessage`
            }
          />
        </Box>
      )}
      {haveServiceProperties && (
        <ServiceProperties
          customServiceWrapper={customServiceWrapper}
          withLimits={withLimits}
          isCrypto={isCrypto}
        />
      )}
      <Box direction="column" top="m" gap="ms" className={customFormWrapper}>
        {children}
      </Box>
    </Box>
  );
};
